// config.js (Firebase v9 modular version)
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA0VhSKxP4MLLizw1ukAw1mrCaBYhkmiRk",
  authDomain: "apex-yeild.firebaseapp.com",
  databaseURL: "https://apex-yeild-default-rtdb.firebaseio.com",
  projectId: "apex-yeild",
  storageBucket: "apex-yeild.firebasestorage.app",
  messagingSenderId: "626549219225",
  appId: "1:626549219225:web:e14ab251269497b4903d08"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Export the needed services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { auth, db, storage };

